import React, { useState, useContext } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './FitFinder.css';
import { AppContext } from "../main";

const FitFinder = () => {
  const { appState } = useContext(AppContext);
  const { fashionInfo = {
    heading: 'Find Your Perfect Fit',
    images: [
      'https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg',
      'https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg',
      'https://varefiles.s3.us-east-2.amazonaws.com/meetingpic2.jpg',
    ],
    labels: {
      chest: 'Chest (in inches):',
      waist: 'Waist (in inches):',
      height: 'Height (in inches):',
      resultHeader: 'Your Best Fit',
      jacketLabel: 'Jacket',
      pantsLabel: 'Pants',
      buttonText: 'Get My Fit',
    },
    getJacketSize: (chestSize) => {
      if (chestSize >= 34 && chestSize <= 36) return '36';
      if (chestSize <= 38) return '38';
      if (chestSize <= 40) return '40';
      if (chestSize <= 42) return '42';
      return '44';
    },
    getLength: (heightInches) => {
      if (heightInches < 66) return 'Short';
      if (heightInches <= 72) return 'Regular';
      return 'Long';
    },
    getPantSize: (waistSize, length) => {
      const inseam = length === 'Short' ? 30 : length === 'Regular' ? 32 : 34;
      return `${waistSize} x ${inseam}`;
    }
  }
  } = appState;


  const [measurements, setMeasurements] = useState({
    chest: '',
    waist: '',
    height: '',
  });

  const [fitResult, setFitResult] = useState(null);

  const handleChange = (e) => {
    setMeasurements({ ...measurements, [e.target.name]: e.target.value });
  };

  const handleCalculate = () => {
    const { chest, waist, height } = measurements;
    const chestSize = parseInt(chest);
    const waistSize = parseInt(waist);
    const heightInches = parseInt(height);

    const jacketSize = fashionInfo.getJacketSize(chestSize);
    const length = fashionInfo.getLength(heightInches);
    const pantSize = fashionInfo.getPantSize(waistSize, length);

    setFitResult({
      jacket: `${jacketSize} ${length}`,
      pants: pantSize,
    });
  };

  if (!fashionInfo?.images || !fashionInfo?.heading) return null;


  return (
    <div className="fit-finder-wrapper" style={{ position: 'relative', marginTop: 120, borderRadius: 10, overflow: 'hidden' }}>
      <video
        autoPlay
        muted
        loop
        playsInline
        className="background-video"
        src="https://varefiles.s3.us-east-2.amazonaws.com/school-teacher2.mp4"// or your own video
      />
      <div className="fit-finder-content" style={{ position: 'relative', zIndex: 1 }}>
        <div className="carousel-container">
          <Carousel autoPlay infiniteLoop showThumbs={false}>
            {fashionInfo.images.map((url, idx) => (
              <div key={idx}>
                <img src={url} alt={`Suit ${idx + 1}`} style={{
                  borderRadius: 10
                }} />
              </div>
            ))}
          </Carousel>
        </div>

        <div className="fit-finder">
          <h2>{fashionInfo.heading}</h2>

          <div className="form">
            <label>{fashionInfo.labels?.chest}</label>
            <input type="number" name="chest" value={measurements.chest} onChange={handleChange} style={{ color: 'black' }} />

            <label>{fashionInfo.labels?.waist}</label>
            <input type="number" name="waist" value={measurements.waist} onChange={handleChange} style={{ color: 'black' }} />

            <label>{fashionInfo.labels?.height}</label>
            <input type="number" name="height" value={measurements.height} onChange={handleChange} style={{ color: 'black' }} />

            <button onClick={handleCalculate}>{fashionInfo.labels?.buttonText}</button>
          </div>

          {fitResult && (
            <div className="result">
              <h3>{fashionInfo.labels?.resultHeader}</h3>
              <p><strong>{fashionInfo.labels?.jacketLabel}:</strong> Size {fitResult.jacket}</p>
              <p><strong>{fashionInfo.labels?.pantsLabel}:</strong> Size {fitResult.pants}</p>

              <div className="alignment-box">
                <div>Just Right</div>
                <div>← {fitResult.jacket} →</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FitFinder;
